import { useConnectionStatus } from "../hooks/useConnectionStatus";
import { Button } from "@dawa/ui";

interface LightProps {
  connected: boolean | null;
  label: string;
  onClick: () => void;
  error: string | null;
}

function Light({ connected, label, onClick, error }: LightProps) {
  let color = "bg-neutral/30";
  if (connected === true) color = "bg-success";
  if (connected === false) color = "bg-danger";
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="flex items-center space-x-1"
      onClick={onClick}
      title={error || undefined}
    >
      <span className={`h-2.5 w-2.5 rounded-full ${color}`} />
      <span className="text-xs text-secondary">{label}</span>
    </Button>
  );
}

export function ConnectionStatus() {
  const {
    openAIConnected,
    supabaseConnected,
    checkOpenAI,
    checkSupabase,
    openAIError,
    supabaseError,
  } = useConnectionStatus();
  return (
    <div className="flex items-center space-x-3">
      <Light connected={openAIConnected} label="OpenAI" onClick={checkOpenAI} error={openAIError} />
      <Light
        connected={supabaseConnected}
        label="DB"
        onClick={checkSupabase}
        error={supabaseError}
      />
    </div>
  );
}

export default ConnectionStatus;
